import axios from "axios";

export default async function editDocument(projectName, formName, documentId, data){
    return await axios.patch(`/project/${projectName}/${formName}/document/${documentId}/edit`, {...data});
}